import {
  FETCH_CREDITNOTESDETAILS_SUCCESS_ACTION,
  FETCH_CREDITNOTESSEARCH_SUCCESS_ACTION
} from "./action";

const initialState = {
  processing: false,
  error: false
};

export default function(state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_CREDITNOTESDETAILS_SUCCESS_ACTION:
      // console.log(
      //   "&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&",
      //   action.payload.rows
      // );
      return {
        ...state,
        CreditNotesDtlsList: action.payload.rows,
        CreditNoteslsCount: action.payload.count
      };

    case FETCH_CREDITNOTESSEARCH_SUCCESS_ACTION:
      return {
        ...state,
        CreditNotesSearchList: action.payload.rows,
        CreditNotesSearchCount: action.payload.count
      };

    default:
      return {
        ...state
      };
  }
}
